import * as Types from 'src/actions/physical-person/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import ValidatorService from 'src/services/validation/Validation.service';

export interface GetPhysicalPersonAttempt extends Action {
  type: Types.GET_PHYSICAL_PERSON_ATTEMPT;
}

export interface GetPhysicalPersonSuccess extends Action {
  type: Types.GET_PHYSICAL_PERSON_SUCCESS;
  payload: PhysicalPerson;
}

export interface GetPhysicalPersonFailure extends Action {
  type: Types.GET_PHYSICAL_PERSON_FAILURE;
  payload: {};
}

export type GetPhysicalPersonAction = GetPhysicalPersonAttempt | GetPhysicalPersonSuccess | GetPhysicalPersonFailure;

export interface GetPhysicalPersonThunk extends ThunkAction<Promise<GetPhysicalPersonAction>, RootState, null> {
}

export const getPhysicalPersonAttempt: ActionCreator<GetPhysicalPersonAttempt> = () => (
  { type: Types.GET_PHYSICAL_PERSON_ATTEMPT }
);

export const getPhysicalPersonSuccess: ActionCreator<GetPhysicalPersonSuccess> = (physicalPerson: PhysicalPerson) => (
  {
    type: Types.GET_PHYSICAL_PERSON_SUCCESS,
    payload: physicalPerson
  }
);

export const getPhysicalPersonFailure: ActionCreator<GetPhysicalPersonFailure> = (error: {}) => (
  {
    type: Types.GET_PHYSICAL_PERSON_FAILURE,
    payload: error
  }
);

export const getPhysicalPerson: ActionCreator<GetPhysicalPersonThunk> = (
  physicalPersonId: number
): GetPhysicalPersonThunk => {

  return (dispatch: Dispatch<RootState>): Promise<GetPhysicalPersonAction> => {
    dispatch(getPhysicalPersonAttempt());

    return ApiClient.physicalPerson.get(physicalPersonId)
      .then((response: AxiosResponse<PhysicalPerson>): GetPhysicalPersonSuccess => {

        const physicalPerson: PhysicalPerson = response.data;

        return dispatch(getPhysicalPersonSuccess(physicalPerson));
      }).catch((e: { response: { data: { error: {} } } }): GetPhysicalPersonFailure => {
        const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);

        return dispatch(getPhysicalPersonFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/physical-person/get/GetPhysicalPerson.actions.tsx